module.exports = __webpack_public_path__ + "img/deactivate_white.ad20c49f.svg";